export const legacyTypes = {
  LIST_LEGACY: 'LIST_LEGACY_DISTRIBUTOR',
  LIST_LEGACY_SUCCESS: 'LIST_LEGACY_DISTRIBUTOR_SUCCESS',
  LIST_LEGACY_FAIL: 'LIST_LEGACY_DISTRIBUTOR_FAIL',
  
};
